export const HERO_SLUG_BY_LABEL: Record<string, string> = {
  'Perda de peso e controle de apetite': 'peso',
  'Diabetes': 'diabetes',
  'Hipertensão e saúde cardiovascular': 'hipertensao',
  'Dor crônica': 'dor',
  'Fibromialgia': 'fibromialgia',
  'Sono e insônia': 'insonia',
  'Endometriose': 'endometriose',
  'Asma e condições pulmonares': 'pulmonar',
  'Oncologia': 'oncologia',
  'Estresse, ansiedade e saúde mental': 'ansiedade',
  'Saúde da mulher': 'mulher',
  'Disfunção erétil': 'disfuncao_eretil',
  'Dor e fibromialgia': 'dor',
  'Saúde mental': 'ansiedade',
  'Perda de peso': 'peso',
  'Saúde cardiovascular': 'hipertensao',
  'Asma': 'pulmonar'
}

export const HERO_SLUGS = new Set(Object.values(HERO_SLUG_BY_LABEL))

export const isNewHomeScreening = (module: {
  slug: string
  custom?: boolean
  group_slug?: string | null
}) => Boolean(module.custom) && module.group_slug !== 'mulher' && !HERO_SLUGS.has(module.slug)
